import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App/App';
import { addContent } from './utils/addContent';

if (process.env.NODE_ENV !== 'production') {
  require('./stubs');
}

const loadApp = () => {
  const storeRoot = document.getElementById('store-root');
  const storeId = storeRoot.getAttribute('data-store-id');
  const storeEnv = storeRoot.getAttribute('data-store-env');

  fetch(
    `https://storage.googleapis.com/ofw-store-builder/${storeId}/${storeEnv}.json`,
    {
      mode: 'cors'
    }
  ).then(resp => {
    if (resp.ok) {
      return resp.json().then(json => {
        if (!window.location.hash) {
          window.history.pushState({}, '', `${window.location.pathname}#/`);
        }
        const base = window.document.getElementsByTagName('base');
        for (let i = 0; i < base.length; i++) {
          base[i].parentNode.removeChild(base[i]);
        }

        // For the store prop use addContent(json, 'collage') to add test content blocks
        ReactDOM.render(<App store={json} storeId={storeId} />, storeRoot);
      });
    }
  });
};

// Hack to force display of pre-order products
if (window.ow && window.ow.url) {
  window.ow.url.IntelligentOfferURL =
    '/shop/OWIntelligentOffer?catalogId=10551&langId=-1';
}

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

if (typeof window.document !== 'undefined') {
  if (
    window.document.readyState === 'complete' ||
    // !IE 8-10
    (window.document.readyState !== 'loading' &&
      !window.document.documentElement.doScroll)
  ) {
    loadApp();
  } else {
    window.document.addEventListener('DOMContentLoaded', loadApp);
  }
}



// WEBPACK FOOTER //
// ./src/index.js